import React, { useState } from 'react';
import { Form } from '@ant-design/compatible';

import GeneratePointUserDetailModalView from './GeneratePointUserDetailModalView';

const GeneratePointUserDetailModalContainer = (props) => {
  const { userPersonalInfo, form, closeModal, checkValidGeneratePoint, pointCauseSelectList } = props;
  const [pointCauseId, setPointCauseId] = useState();
  const [type, setType] = useState();
  const [amount, setAmount] = useState();

  const initCause = () => setPointCauseId(null);

  const handleSubmit = (pointUserDetail) => {
    const userData = {
      cellPhone: userPersonalInfo.cellPhone,
      name: userPersonalInfo.name,
      id: userPersonalInfo.userId,
      userId: userPersonalInfo.userId,
      status: userPersonalInfo.status,
      pointAmount: userPersonalInfo.pointAmount,
      usedPointAmount: userPersonalInfo.usedPointAmount,
    };

    /**
     *  form 유효성 체크
     */
    form.validateFieldsAndScroll((err) => {
      if (err) {
        return;
      }

      /**
       *  유효성 체크 하는 ctrl 로 보낸다.
       */
      checkValidGeneratePoint([{ ...userData, ...pointUserDetail }]);

      closeModal();
    });
  };

  return (
    <GeneratePointUserDetailModalView
      userPersonalInfo={userPersonalInfo}
      pointCauseSelectList={pointCauseSelectList}
      form={form}
      closeModal={closeModal}
      initCause={initCause}
      onSubmit={handleSubmit}
      pointUserDetail={{
        type,
        pointCauseId,
        amount,
      }}
      setPointCauseId={setPointCauseId}
      setType={setType}
      setAmount={setAmount}
    />
  );
};

export default Form.create({})(GeneratePointUserDetailModalContainer);
